import type React from 'react'
import { cn } from '../../../shared/cn'

export function P1({ className, ...props }: React.ComponentPropsWithoutRef<'p'>) {
  return (
    <p {...props} className={cn('font-normal text-contentPrimary text-xl leading-8', className)} />
  )
}
